import DateFormatter from "./DateFormatter";
export default DateFormatter;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/utils/DateFormatter/index.tsx